const CloudSvg = () => (
  <svg
    width="600"
    height="788"
    viewBox="0 0 1153 1517"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1080.33 492.928C1176.58 589.179 1176.58 744.855 1079.5 841.943C1077.82 843.617 1063.59 857.845 958.973 962.466C886.157 1035.28 769.819 1151.62 584.013 1337.43L495.295 1426.14C381.468 1544.99 195.662 1544.99 83.5084 1432.84C-29.4819 1319.85 -29.4819 1132.37 94.3888 1020.22C-120.711 602.571 387.326 183.251 753.917 471.167C851.842 395.004 990.778 403.373 1080.33 492.928Z"
      fill="white"
    />
    <path
      d="M825.665 1159.35C1005.08 979.938 1005.78 688.317 826.14 508.68C646.502 329.042 354.881 329.738 175.465 509.154C-3.95102 688.57 -4.64692 980.191 174.991 1159.83C354.628 1339.47 645.374 1339.65 825.665 1159.35Z"
      fill="white"
    />
    <path
      d="M945.27 337.352C869.423 261.505 746.266 261.089 670.477 336.877C594.688 412.666 595.105 535.823 670.952 611.67C746.798 687.516 869.956 687.933 945.744 612.144C1021.53 536.356 1021.49 413.568 945.27 337.352Z"
      fill="white"
    />
    <path
      d="M928.184 101.951C880.584 54.3507 803.371 54.01 755.905 101.476C708.439 148.943 708.779 226.155 756.379 273.756C803.98 321.356 881.192 321.696 928.659 274.23C976.125 226.764 976.016 149.783 928.184 101.951Z"
      fill="white"
    />
    <path
      d="M788.652 218.702C723.267 153.317 617.126 152.929 551.827 218.228C486.529 283.526 486.917 389.667 552.302 455.052C617.687 520.437 723.828 520.826 789.127 455.527C854.426 390.228 854.356 284.406 788.652 218.702Z"
      fill="white"
    />
    <path
      d="M1079.5 841.935C1175.75 745.684 1176.59 589.172 1080.34 492.921C984.086 396.67 827.574 397.507 731.323 493.758C635.072 590.009 634.235 746.521 730.486 842.772C826.737 939.023 983.249 938.186 1079.5 841.935Z"
      fill="white"
    />
    <path
      d="M901.369 221.262C951.779 271.672 1033.77 271.808 1084.32 221.262C1134.87 170.716 1134.73 88.7207 1084.32 38.3107C1033.91 -12.0994 951.915 -12.2353 901.369 38.3107C850.823 88.8567 850.713 170.606 901.369 221.262Z"
      fill="white"
    />
    <path
      d="M720.241 495.777C502.41 495.777 324.958 672.385 324.958 890.484C324.958 1108.58 502.411 1285.19 720.241 1285.19C938.072 1285.19 1115.52 1108.58 1115.52 890.484C1115.52 672.384 939.135 495.777 720.241 495.777Z"
      fill="white"
    />
    <path
      d="M791.019 557.088C871.835 637.904 1003.29 638.121 1084.32 557.088C1165.35 476.054 1165.14 344.602 1084.32 263.786C1003.51 182.97 872.052 182.752 791.019 263.786C709.985 344.819 709.809 475.878 791.019 557.088Z"
      fill="white"
    />
  </svg>
);

export default CloudSvg;
